(() => {
  const PRODUCT_IDS = {
    core: "10316215255377", // Kaiju -> 28 sticks
    kick: "10342454100305", // Kaiju Kick -> 12 sticks
    pack: "10448039706961", // Performance Pack -> special labels + compare
  };

  const STICKS_BY_PRODUCT_ID = {
    [PRODUCT_IDS.core]: 28,
    [PRODUCT_IDS.kick]: 12,
  };

  /* -------------------------
     currency helpers (PATCH)
  ------------------------- */

  const isUkRegion = () => {
    const country = String(window.Shopify?.country || "").toUpperCase();
    const activeCurrency = String(
      window.Shopify?.currency?.active ||
        window.Shopify?.currency?.activeCurrency ||
        ""
    ).toUpperCase();
    const locale = String(
      window.Shopify?.locale || document.documentElement.lang || ""
    ).toLowerCase();

    return country === "GB" || activeCurrency === "GBP" || locale.includes("en-gb");
  };

  const formatCurrency = (amount) => {
    const currency = String(
      window.Shopify?.currency?.active ||
        window.Shopify?.currency?.activeCurrency ||
        "EUR"
    ).toUpperCase();

    try {
      const parts = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).formatToParts(Number(amount));

      const symbol = parts.find((p) => p.type === "currency")?.value || "";
      const number = parts
        .filter((p) => p.type !== "currency")
        .map((p) => p.value)
        .join("")
        .trim();

      // UK: symbol before
      if (isUkRegion()) return `${symbol}${number}`.trim();

      // others: symbol after
      return `${number}${symbol}`.trim();
    } catch (_) {
      const n = Number(amount).toFixed(2);
      if (currency === "GBP") return `£${n}`;
      if (currency === "USD") return `$${n}`;
      return `${n}€`;
    }
  };

  /* -------------------------
     utils existants
  ------------------------- */

  const moneyTextToNumber = (str) => {
    const s = String(str || "").trim();
    if (!s) return null;

    let cleaned = s.replace(/\s/g, "").replace(/[^\d,.-]/g, "");

    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        cleaned = cleaned.replace(/\./g, "").replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (lastComma > -1 && lastDot === -1) {
      cleaned = cleaned.replace(",", ".");
    }

    const n = Number(cleaned);
    return Number.isFinite(n) ? n : null;
  };

  const round2 = (n) => Math.round(n * 100) / 100;

  /* -------------------------
     per serving (PATCHED)
  ------------------------- */

  const formatPerStick = (price, sticksCount) => {
    const perServing = round2(price / sticksCount);
    return `${formatCurrency(perServing)} / stick`;
  };

  /* -------------------------
     perf pack labels
  ------------------------- */

  const isFr = () => {
    const locale = String(
      window.Shopify?.locale || document.documentElement.lang || ""
    ).toLowerCase();
    return locale.startsWith("fr");
  };

  const PERF_LABELS = {
    subscription: "Kick + Hydratation",
    onetime: () => (isFr() ? "Économisez 10% avec le pack" : "Save 10% with the pack"),
  };

  /* -------------------------
     product json helpers
  ------------------------- */

  const getKxoProductData = (kxoRoot) => {
    const jsonEl = kxoRoot.querySelector(
      'script[type="application/json"][data-kxo-product-json], script[data-kxo-product-json]'
    );
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || "{}");
    } catch (_) {
      return null;
    }
  };

  // returns { priceCents, compareCents } from first variant (simple + stable)
  const getVariantPrices = (kxoRoot) => {
    const data = getKxoProductData(kxoRoot);
    const v = data?.variants?.[0];
    if (!v) return null;

    const priceCents = Number(v.price);
    const compareCents = Number(v.compare_at_price);

    if (!Number.isFinite(priceCents)) return null;

    return {
      priceCents,
      compareCents: Number.isFinite(compareCents) ? compareCents : 0,
    };
  };

  /* -------------------------
     product id resolution
  ------------------------- */

  const getKxoProductId = (kxoRoot) => {
    const fromSpan = kxoRoot
      .querySelector("[data-atc-perstick]")
      ?.getAttribute("data-product-id");
    if (fromSpan) return String(fromSpan);

    const fromAttr = kxoRoot.getAttribute("data-product-id") || kxoRoot.dataset.productId;
    if (fromAttr) return String(fromAttr);

    const data = getKxoProductData(kxoRoot);
    if (data?.id) return String(data.id);

    return "";
  };

  /* -------------------------
     main updater
  ------------------------- */

  const updateKxoModulePerStick = (kxoRoot) => {
    const productId = getKxoProductId(kxoRoot);

    const subOption = kxoRoot
      .querySelector('input[type="radio"][value="subscription"]')
      ?.closest(".appstle_subscription_wrapper_option");

    const otOption = kxoRoot
      .querySelector('input[type="radio"][value="onetime"]')
      ?.closest(".appstle_subscription_wrapper_option");

    const subPerStickEl = subOption?.querySelector("[data-atc-perstick]");
    const otPerStickEl = otOption?.querySelector("[data-atc-perstick]");

    const allPerStickEls = kxoRoot.querySelectorAll("[data-atc-perstick]");

    /* ---------- PERF PACK special copy + correct compare ---------- */
    if (productId === PRODUCT_IDS.pack) {
      // show custom labels instead of per-serving
      allPerStickEls.forEach((el) => {
        el.hidden = false;
      });

      if (subPerStickEl) {
        const next = PERF_LABELS.subscription;
        if (subPerStickEl.textContent !== next) subPerStickEl.textContent = next;
        subPerStickEl.hidden = false;
      }

      if (otPerStickEl) {
        const next =
          typeof PERF_LABELS.onetime === "function"
            ? PERF_LABELS.onetime()
            : PERF_LABELS.onetime;
        if (otPerStickEl.textContent !== next) otPerStickEl.textContent = next;
        otPerStickEl.hidden = false;
      }

      // FIX: force the compare price for onetime from product JSON (compare_at_price)
      if (otOption) {
        const currentEl = otOption.querySelector('.kxo-price [data-kxo-price="onetime"]');
        const compareEl = otOption.querySelector(".kxo-price .kxo-price--compare");

        if (currentEl && compareEl) {
          const prices = getVariantPrices(kxoRoot);
          if (prices) {
            const { priceCents, compareCents } = prices;

            // show compare only if compare_at > price (normal Shopify semantics)
            if (compareCents > priceCents) {
              const nextCompare = formatCurrency(compareCents / 100);

              if (compareEl.textContent !== nextCompare) compareEl.textContent = nextCompare;
              compareEl.hidden = false;
              compareEl.style.display = "";
            } else {
              // hide compare if invalid / reversed
              compareEl.hidden = true;
              compareEl.textContent = "";
            }
          }
        }
      }

      // keep hiding per-stick inside KXO internal ajax button (unchanged)
      kxoRoot.querySelectorAll(".kxo-atc [data-atc-perstick]").forEach((el) => {
        el.hidden = true;
        el.textContent = "";
      });

      return;
    }

    /* ---------- CORE/KICK unchanged ---------- */
    const sticksCount = STICKS_BY_PRODUCT_ID[productId];

    // other products -> hide per-stick
    if (!sticksCount) {
      allPerStickEls.forEach((el) => {
        el.hidden = true;
        el.textContent = "";
      });
      return;
    }

    const subPriceEl = kxoRoot.querySelector('[data-kxo-price="subscription"]');
    const otPriceEl = kxoRoot.querySelector('[data-kxo-price="onetime"]');

    const subPrice = moneyTextToNumber(subPriceEl?.textContent);
    const otPrice = moneyTextToNumber(otPriceEl?.textContent);

    if (subPerStickEl) {
      if (subPrice == null) {
        subPerStickEl.hidden = true;
        subPerStickEl.textContent = "";
      } else {
        const next = formatPerStick(subPrice, sticksCount);
        if (subPerStickEl.textContent !== next) subPerStickEl.textContent = next;
        subPerStickEl.hidden = false;
      }
    }

    if (otPerStickEl) {
      if (otPrice == null) {
        otPerStickEl.hidden = true;
        otPerStickEl.textContent = "";
      } else {
        const next = formatPerStick(otPrice, sticksCount);
        if (otPerStickEl.textContent !== next) otPerStickEl.textContent = next;
        otPerStickEl.hidden = false;
      }
    }

    // per-stick in internal KXO ajax button -> hide (unchanged)
    kxoRoot.querySelectorAll(".kxo-atc [data-atc-perstick]").forEach((el) => {
      el.hidden = true;
      el.textContent = "";
    });
  };

  const updateAll = () => {
    document.querySelectorAll("[data-kxo-root]").forEach(updateKxoModulePerStick);

    // fallback Shopify buttons outside KXO (leave as-is, and keep hiding for pack)
    document.querySelectorAll('button[id^="ProductSubmitButton-"]').forEach((btn) => {
      const perStickEl = btn.querySelector("[data-atc-perstick]");
      if (!perStickEl) return;

      const form = btn.closest("form") || btn.closest(".shopify-section") || document;
      if (form.querySelector("[data-kxo-root]")) return;

      const productId = String(perStickEl.getAttribute("data-product-id") || "");

      // performance pack -> hide in fallback context
      if (productId === PRODUCT_IDS.pack) {
        perStickEl.hidden = true;
        perStickEl.textContent = "";
        return;
      }

      const sticksCount = STICKS_BY_PRODUCT_ID[productId];

      if (!sticksCount) {
        perStickEl.hidden = true;
        perStickEl.textContent = "";
        return;
      }

      const scope = btn.closest(".shopify-section") || btn.closest("section") || document;

      const priceEl =
        scope.querySelector(".price .price-item--sale") ||
        scope.querySelector(".price .price-item--regular") ||
        scope.querySelector(".price__container .price-item") ||
        scope.querySelector(".product__info-container .price .price-item");

      const price = moneyTextToNumber(priceEl?.textContent);
      if (price == null) {
        perStickEl.hidden = true;
        perStickEl.textContent = "";
        return;
      }

      const next = formatPerStick(price, sticksCount);
      if (perStickEl.textContent !== next) perStickEl.textContent = next;
      perStickEl.hidden = false;
    });
  };

  let raf = null;
  const scheduleUpdate = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      updateAll();
    });
  };

  const init = () => {
    updateAll();

    // warmup async
    let tries = 0;
    const warmup = () => {
      updateAll();
      tries += 1;
      if (tries < 90) requestAnimationFrame(warmup);
    };
    requestAnimationFrame(warmup);

    document.addEventListener("click", scheduleUpdate);
    document.addEventListener("change", scheduleUpdate);
    document.addEventListener("input", scheduleUpdate);

    const obs = new MutationObserver(scheduleUpdate);
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["checked", "value", "class", "style", "hidden", "aria-hidden"],
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();